import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usage-terms',
  templateUrl: './usage-terms.component.html',
  styleUrls: ['./usage-terms.component.css'],
})
export class UsageTermsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
